import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';


const SpinnerLoader = ({ size = 60, color = '#638DFF' }) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1300,
            }}
        >
            <CircularProgress
                size={size}
                sx={{ color}}
            />
        </Box>
    );
};

export default SpinnerLoader;
